import { createGlobalStyle } from 'styled-components'
import '@beeq/core/dist/beeq/beeq.css'

export const GlobalStyle = createGlobalStyle`
// overrides bq-theme='endava' font-family to default font of bq-theme='beeq'
.endava, [bq-theme=endava] {
  --bq-font-family: "Outfit"
}



body {
    box-sizing: border-box;
    font-family: var(--bq-font-family), 'Poppins', sans-serif;
    font-weight: var(--bq-font-weight--regular);
    height: unset;
    width:unset;
}

a {
  color: inherit; /* resets default blue color */
  text-decoration: inherit; /* resets default underline */
  :hover {
    color: inherit;  /* resets default blue hover color */
  }
}

`
